// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"721":"753a5d02","787":"fea1d566"}[chunkId] + ".chunk.js";
};